import { StateService } from '@uirouter/angular';

import { Injectable } from '@angular/core';

import { GfTranslateService } from '../../../../services/core.translate.service';
import { ProjectService } from '../../../../services/project.service';
import { UserService } from '../../../../services/core.user.service';

import * as _ from 'lodash';
@Injectable()
export class ActivityReportHelper {

    constructor(
        private gfTranslateService: GfTranslateService,
        private stateService: StateService,
        private projectService: ProjectService,
        private userService: UserService,
    ) {
    }

    getSortFields() {
        return {
            'id': this.gfTranslateService.translate('ID'),
            'activityDate': this.gfTranslateService.translate('Activity Date'),
            'description': this.gfTranslateService.translate('Description'),
            'userId': this.gfTranslateService.translate('By (User)')
        };
    }
    getAnyFilterObj() {
        return { id: '', label: this.gfTranslateService.translate("Any"), defaultSelected: true };
    }
    getCustomFilterObj() {
        return { id: null, label: this.gfTranslateService.translate("Custom"), defaultSelected: false };
    }
    getYesNoElements() {
        return [
            { id: 'N', label: this.gfTranslateService.translate('No'), defaultSelected: true },
            { id: 'Y', label: this.gfTranslateService.translate('Yes') }
        ];
    }
    getElementFromUser = (u) => {
        return {
            id: u.id,
            label: this.userService.fullName(u)
        };
    }
    getProjectMembers(q = null) {
        var params = {
            group: 'false',  // include group members, not groups
            type: 'history',
            page_size: 999,
            search: null
        };

        if (q) {
            params.search = q;
        }

        return new Promise(
            (resolve, reject) => {
                this.projectService.members(this.stateService.params.unixName, params)
                    .then(
                        (result) => {
                            var elements = _.concat(
                                [this.getAnyFilterObj()],
                                _.map(_.get(result, 'items', []), this.getElementFromUser)
                            );
                            resolve(elements);
                        }, (response) => {
                            console.log(response);

                            var elements = [this.getAnyFilterObj()]
                                .concat(_.get(response, 'items', []));
                            resolve(elements);
                        }
                    );
            }
        )
    }
    getActivityTypeElements() {
        return [
            this.getAnyFilterObj(),
            { id: 'scmcommit', label: this.gfTranslateService.translate("SCM Commit") },
            { id: 'forumthread', label: this.gfTranslateService.translate("Discussions") },
            { id: 'docmanfile', label: this.gfTranslateService.translate("Docman") },
            { id: 'frspackage', label: this.gfTranslateService.translate("FRS Package") },
            { id: 'frsrelease', label: this.gfTranslateService.translate("FRS Release") },
            { id: 'project', label: this.gfTranslateService.translate("Project") },
            { id: 'trackeritem', label: this.gfTranslateService.translate("Tracker Item") },
            { id: 'wiki', label: this.gfTranslateService.translate("Wiki") }
        ];
    }
    getDateRangeElements() {
        return [
            { id: '-7 days', label: this.gfTranslateService.translate("This Week"), defaultSelected: true },
            { id: '-15 days', label: this.gfTranslateService.translate("Last 15 days") },
            { id: '-30 days', label: this.gfTranslateService.translate("Last 30 days") },
            { id: '-60 days', label: this.gfTranslateService.translate("Last 60 days") },
            { id: '-90 days', label: this.gfTranslateService.translate("Last 90 days") },
            { id: '-365 days', label: this.gfTranslateService.translate("Last year") }
        ];
    }
    getBaseFilters() {
        var any = this.getAnyFilterObj();
        var yesNo = this.getYesNoElements();
        var dateRanges = this.getDateRangeElements();

        var ret = [
            { alias: "section", fieldName: this.gfTranslateService.translate("Activity type"), value: any, fieldType: 1, isExtraField: false, fieldElements: this.getActivityTypeElements() },
            { alias: "subprojects", fieldName: this.gfTranslateService.translate("Include Subprojects"), value: yesNo[0], fieldType: 1, isExtraField: false, fieldElements: yesNo },
            { alias: "activityDateFrom", fieldName: this.gfTranslateService.translate("Start Date"), value: '', fieldType: 9, isExtraField: false },
            { alias: "activityDateTo", fieldName: this.gfTranslateService.translate("End Date"), value: '', fieldType: 9, isExtraField: false },
            { alias: "rangeDate", fieldName: this.gfTranslateService.translate("Date Range"), value: dateRanges[0], fieldType: 1, isExtraField: false, fieldElements: dateRanges },
            { alias: "userId", fieldName: this.gfTranslateService.translate("Member"), value: any, fieldType: 1, isExtraField: false, fieldElements: [any] }
        ];
        return ret;
    }
    getSelectedElement(filter, stateParams) {
        var val = _.get(stateParams, filter.alias, false) || '';
        var elem = _.find(filter.fieldElements, { id: val });
        if (!elem) {
            elem = _.find(filter.fieldElements, { defaultSelected: true });
        }
        return elem;
    }
    setFiltersFromStateParams(filters, stateParams) {
        return _.map(
            filters,
            (f) => {
                switch (f.fieldType) {
                    case 1: // list
                        f.value = this.getSelectedElement(f, stateParams);
                        break;

                    default: // text/other
                        f.value = _.get(stateParams, f.alias, '');
                        break;
                }
                return f;
            }
        );
    }
}